import React from 'react';
import { Link, Outlet, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Linkedin, Mail } from 'lucide-react';
export function Layout() {
  const location = useLocation();
  const navLinks = [{
    path: '/',
    label: 'Home'
  }
  // {
  //   path: '/work',
  //   label: 'Work',
  // },
  ];
  return <div className="min-h-screen flex flex-col bg-white text-black selection:bg-black selection:text-white" data-id="element-14">
      <header className="sticky top-0 z-50 bg-white/80 backdrop-blur-md border-b border-gray-100" data-id="element-15">
        <div className="max-w-5xl mx-auto px-6 h-20 flex items-center justify-between" data-id="element-16">
          <Link to="/" className="font-semibold text-lg tracking-tight" data-id="element-17">
            Tien Mai
          </Link>
          <nav className="hidden md:flex items-center gap-8 text-sm font-medium" data-id="element-18">
            {navLinks.map(link => <Link key={link.path} to={link.path} className={`relative py-2 transition-colors hover:text-black ${location.pathname === link.path ? 'text-black' : 'text-gray-500'}`} data-id="element-19">
                {link.label}
                {location.pathname === link.path && <motion.div layoutId="underline" className="absolute left-0 right-0 bottom-0 h-px bg-black" data-id="element-20" />}
              </Link>)}
          </nav>

          {/* Mobile Nav - temporarily hidden
           <nav className="flex md:hidden items-center gap-4 text-sm font-medium">
           <Link to="/work" className="text-gray-600">
            Work
           </Link>
           </nav>
           */}
        </div>
      </header>

      <main className="flex-grow" data-id="element-21">
        <Outlet data-id="element-22" />
      </main>

      <footer className="border-t border-gray-100 py-12 mt-24" data-id="element-23">
        <div className="max-w-5xl mx-auto px-6 flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-24">
          <p className="text-sm text-gray-500" data-id="element-25">
            © {new Date().getFullYear()} Product Manager Portfolio. All rights
            reserved.
          </p>
          <div className="flex items-center gap-6" data-id="element-26">
            <a href="https://www.linkedin.com/in/tienmai56/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-black transition-colors" data-id="element-27">
              <Linkedin className="w-5 h-5" data-id="element-28" />
            </a>
            <a href="mailto:mptienmai98@gmail.com" className="text-gray-400 hover:text-black transition-colors" data-id="element-29">
              <Mail className="w-5 h-5" data-id="element-30" />
            </a>
          </div>
        </div>
      </footer>
    </div>;
}